module.exports = __webpack_public_path__ + "static/tymora-symbol-DND3_FnP-15fb32a3f98143cbb89af00246146710.jpg";